var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"breadcrumb"},[_vm._v(_vm._s(_vm.$t("join.legal.breadcrumb")))]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t("join.legal.text"))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d1d622","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/join/components/Legal.vue
// module id = null
// module chunks = 